import styled from '@nexus/lib-react/dist/theme/styled';
import { Global, css } from '@emotion/core';
import React, { memo, useCallback } from 'react';
import { Headline3 } from '@nexus/lib-react/dist/core/Typography/Heading';
import ButtonPrimaryDark from '@nexus/lib-react/dist/core/Button/ButtonPrimaryDark';
import SuccessPicture from '../assets/pay-ship-success-picture.svg';
import mq from '../../../commons/styles/mediaQueries';
import { useI18n } from '../../../i18n';
import S from './style/MarketPayConfirmationSuccess';

const Wrapper = styled.div`
  height: 100%;
  background-color: ${({ theme }) => theme.colors['background-global-primary']};
  font-family: ${({ theme }) => theme.fonts.primary};
  padding-top: 16px;
  font-size: ${({ theme }) => theme.sizes['16']};
  line-height: ${({ theme }) => theme.sizes['20']};

  ${mq.desktop} {
    padding: 32px 64px;
    margin-top: 32px;
  }
`;

const InfoBanner = styled.div`
  background: ${({ theme }) => theme.colors['background-brand-notification-neutral']};
  padding: 20px 16px;
  font-size: ${({ theme }) => theme.fontSizes['14']};
  line-height: ${({ theme }) => theme.lineHeights['18']};
`;

const Title = styled(Headline3)`
  text-align: center;
  font-weight: ${({ theme }) => theme.fontWeights['500']};
  font-size: ${({ theme }) => theme.sizes['32']};
  text-align: left;
  line-height: 34px;
`;
const InfoColumn = styled.div`
  ${mq.desktop} {
    max-width: 328px;
  }
`;
const InfoPar = styled.p`
  text-align: center;

  ${mq.desktop} {
    text-align: left;
  }
`;

const ButtonContainer = styled.div`
  text-align: center;
  margin-top: 32px;
  width: 100%;

  ${mq.desktop} {
    display: flex;
    justify-content: flex-end;
  }
`;

const ConfirmationButton = styled(ButtonPrimaryDark)`
  width: 100%;

  ${mq.desktop} {
    min-width: 193px;
  }
`;
const BoldText = styled.span`
  font-weight: ${({ theme }) => theme.fontWeights['500']};
`;

function ConfirmationSuccessWithoutKyc({
  desktop,
  buttonUrl,
  onClick,
}: {
  desktop: boolean | null;
  buttonUrl: string;
  onClick?: () => void;
}) {
  const i18n = useI18n();

  return (
    <>
      <Global
        styles={css`
          .confirmation-success {
            padding-top: 56px !important;
          }
        `}
      />
      <Title>{i18n`dlv_mp_confirmation_success_title`}</Title>
      <Wrapper>
        <InfoBanner>
          <BoldText>{i18n`dlv_mp_confirmation_success_payu`} </BoldText>
          {i18n`dlv_mp_confirmation_success_payout_details`}
        </InfoBanner>
        <S.DesktopCols>
          {desktop && (
            <S.PictureColumn>
              <SuccessPicture />
            </S.PictureColumn>
          )}
          <InfoColumn>
            <InfoPar>{i18n`dlv_mp_confirmation_success_info1`}</InfoPar>
            <InfoPar>{i18n`dlv_mp_confirmation_success_info2`}</InfoPar>
            <InfoPar>{i18n`dlv_mp_confirmation_success_info3`}</InfoPar>
            <InfoPar>{i18n`dlv_mp_confirmation_success_info4`}</InfoPar>

            <ButtonContainer>
              <ConfirmationButton data-testid="success-btn" as="a" href={buttonUrl}>
                {i18n`dlv_mp_confirmation_success_payout_btn`}
              </ConfirmationButton>
            </ButtonContainer>
          </InfoColumn>
        </S.DesktopCols>
      </Wrapper>
    </>
  );
}

export default memo(ConfirmationSuccessWithoutKyc);

// TODO: add tests
